const exportedObject = {
  getProcedimientosPssData: {},
  getProcedimientosPssLoading: false,
  getProcedimientosPssError: null,

  getMedicosData: {},
  getMedicosLoading: false,
  getMedicosError: null,

  consultarTipoPssNoMedicoData: {},
  consultarTipoPssNoMedicoLoading: false,
  consultarTipoPssNoMedicoError: null,
};

export default exportedObject;